import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { ServerSideDataLoader, PaginationInfo } from "uicomponents";
import { warehouseLocationSearchSelectorViewModel } from "../warehouseLocationManipulation/warehouseLocationManipulation-viewModel";
import { CurrentDistrictWarehousesSelectorViewModel } from "../warehouseManipulation/warehouseManipulation-viewModel";
import  { WarehousePlacementManipulationView } from "./warehousePlacementManipulation-view"
import { downloadFile } from "src/uicomponents/components/utilities";

export class WarehousePlacementManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'تنظیم لوکیشن کالا ';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.warehousePlacement = ObservableArray.create<WarehousePlacement>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.warehouseSelector = new CurrentDistrictWarehousesSelectorViewModel(this, false, false, true, true, false);
        this.warehouseSelector.onSelectionChanged = w =>{
            this.selectedWarehouseId = w.id;
            this.selectedWarehouseName = w.title;
            this.refresh();
            this.isWarehouseSelected = true;
        }
    }
    GetDefaultView(): View <ViewModel> {
        return new WarehousePlacementManipulationView();
    }
    public getTypeId(): string {
        return "VM-8E68B20A-4C71-4813-A936-6E30584E9D47"
    }
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set warehousePlacement(v: ObservableArray<WarehousePlacement>) { this._warehousePlacement = v; } public get warehousePlacement(): ObservableArray<WarehousePlacement> { return this._warehousePlacement;} private _warehousePlacement: ObservableArray<WarehousePlacement>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set warehouseSelector(v: CurrentDistrictWarehousesSelectorViewModel) { this._warehouseSelector = v; } public get warehouseSelector(): CurrentDistrictWarehousesSelectorViewModel { return this._warehouseSelector;} private _warehouseSelector: CurrentDistrictWarehousesSelectorViewModel;
    public set selectedWarehouseName(v: string) { this._selectedWarehouseName = v; } public get selectedWarehouseName(): string { return this._selectedWarehouseName;} private _selectedWarehouseName: string;
    public set selectedWarehouseId(v: string) { this._selectedWarehouseId = v; } public get selectedWarehouseId(): string { return this._selectedWarehouseId;} private _selectedWarehouseId: string;
    public set isWarehouseSelected(v: boolean) { this._isWarehouseSelected = v; } public get isWarehouseSelected(): boolean { return this._isWarehouseSelected;} private _isWarehouseSelected: boolean;
    
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetProductPlacesInWarehouse',{
                FurtherQueryInfo:filteringInformation,
                WarehouseId:this.selectedWarehouseId
            });
            let rowNumber = 1;
            this.warehousePlacement.update(...result.MeasuredProducts.map(q=>{
                let r = new WarehousePlacement(this);
                r.id = q.Id;
                r.rowNumber = rowNumber++;
                r.measuredProductId = q.MeasuredProductId;
                r.productName = q.ProductName;
                r.productCode = q.ProductCode;
                r.productCarModel = q.ProductCarModel;
                r.unitName = q.UnitName;
                r.setWarehouseId(this.selectedWarehouseId);
                r.warehouseName = this.selectedWarehouseName;
                r.joinWarehouseNames = q.Locations.map(w=>w.Name).join(', ');
                r.locations.update(...q.Locations.map(w=> {
                    let l = new Location(r);
                    l.locationId = w.Id;
                    l.name = w.Name;
                    return l;
                }));
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    async setPlacementBatch() {
        if(this.warehouseSelector.selectedItem==null){
            this.messageBoxConfirmWarning('هیچ انباری انتخاب نشده است.','خطا');
            return;
        }
        let popup = new batchPlacementUpdater(this,this.warehouseSelector.selectedItem.id);
        let result = await this.requestShowingPopup(popup)
        if(result==true){
            this.loader.refresh()
        }
    }

    async warehousePlacementUpdater(warehousePlacement:WarehousePlacement){
        // let editor = new WarehousePlacement(this);
        // warehousePlacement.cloneTo(editor);
        let resultCode = await this.showPopup(warehousePlacement);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }

    async export(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/ExportPlacementIntoExcelFile',{
                WarehouseId:this.selectedWarehouseId
            });
            await this.messageBoxConfirmSuccess('فایل خروجی با موفقیت بارگذاری شد.','عملیات موفق');
            downloadFile(result.ExcelFile, `export_placement.xlsx`);
            return result;
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
        
}

export class WarehousePlacement extends ViewModel implements IPopup{
    
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:WarehousePlacementManipulationViewModel) {
        super(parent);
        this.locations = ObservableArray.create<Location>();
        this._typedParent = parent;
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set measuredProductId(v: string) { this._measuredProductId = v; } public get measuredProductId(): string { return this._measuredProductId;} private _measuredProductId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode;} private _productCode: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set unitName(v: string) { this._unitName = v; } public get unitName(): string { return this._unitName;} private _unitName: string;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set joinWarehouseNames(v: string) { this._joinWarehouseNames = v; } public get joinWarehouseNames(): string { return this._joinWarehouseNames;} private _joinWarehouseNames: string;
    public set locations(v: ObservableArray<Location>) { this._locations = v; } public get locations(): ObservableArray<Location> { return this._locations;} private _locations: ObservableArray<Location>;
    public set rowNumberBatch(v: number) { this._rowNumberBatch = v; } public get rowNumberBatch(): number { return this._rowNumberBatch;} private _rowNumberBatch: number;
    
    private _typedParent:WarehousePlacementManipulationViewModel;

    setWarehouseId(warehouseId: string) {
        this.warehouseId = warehouseId;
        this.warehouseLocationSelector = new warehouseLocationSearchSelectorViewModel(this,warehouseId);
        this.warehouseLocationSelector.onSelectionChanged = x=>{
            let location = new Location(this);
            location.locationId = x.id;
            location.name = x.title;
            this.locations.push(location);
        };
    }

    getLocations():string[]{
        return this.locations.map(q => q.locationId);
    }

    async edit(){
        this._typedParent.warehousePlacementUpdater(this);
    }  

    closePopup(resultCode: string = null) {
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set warehouseLocationSelector(v: warehouseLocationSearchSelectorViewModel) { this._warehouseLocationSelector = v; } public get warehouseLocationSelector(): warehouseLocationSearchSelectorViewModel { return this._warehouseLocationSelector;} private _warehouseLocationSelector: warehouseLocationSearchSelectorViewModel;
    
    verify():string[]{
        let result :string[] =[];
        return result;
    }

    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت موقعیت');
                return;
            }
            this.isLoading = true;
            await this.execute(this);
            await this.messageBoxConfirmSuccess(this.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    getSuccessMessage(): string {
        return 'لوکیشن کالا با موفقیت تنظیم شد.';
    }
    async execute(warehousePlacement: WarehousePlacement): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/SetProductPlacement',{
            MeasuredProduct:warehousePlacement.measuredProductId,
            WarehouseParty: warehousePlacement.warehouseId,
            Places:warehousePlacement.getLocations()
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }

    
    back(){
        this.closePopup();
    }
    
}

export class Location extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:WarehousePlacement|batchPlacementUpdater) {
        super(parent);
        this._parent = parent;
    }
    
    public set locationId(v: string) { this._locationId = v; } public get locationId(): string { return this._locationId;} private _locationId: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    
    private _parent : WarehousePlacement|batchPlacementUpdater;
    async remove() {
        this._parent.locations.remove(this);
    }
}

export class batchPlacementUpdater extends ViewModel implements IPopup{
    public getTypeId(): string {return 'batch-location-update';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel,warehouseId:string) {
        super(parent);
        this.selectedProducts = ObservableArray.create<singleProduct>();
        this.locations = ObservableArray.create<Location>();
        this.products = ObservableArray.create<singleProduct>();
        this.warehouseId = warehouseId;
        this.warehouseLocationSelector = new warehouseLocationSearchSelectorViewModel(this,warehouseId);
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.warehouseLocationSelector.onSelectionChanged = x=>{
            let location = new Location(this);
            location.locationId = x.id;
            location.name = x.title;
            this.locations.push(location);
        };
        this.loader.refresh();

    }
    closePopup(result?: any) {
    }
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set selectedProducts(v: ObservableArray<singleProduct>) { this._selectedProducts = v; } public get selectedProducts(): ObservableArray<singleProduct> { return this._selectedProducts;} private _selectedProducts: ObservableArray<singleProduct>;
    public set warehouseLocationSelector(v: warehouseLocationSearchSelectorViewModel) { this._warehouseLocationSelector = v; } public get warehouseLocationSelector(): warehouseLocationSearchSelectorViewModel { return this._warehouseLocationSelector;} private _warehouseLocationSelector: warehouseLocationSearchSelectorViewModel;
    public warehouseId:string;
    public set locations(v: ObservableArray<Location>) { this._locations = v; } public get locations(): ObservableArray<Location> { return this._locations;} private _locations: ObservableArray<Location>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set products(v: ObservableArray<singleProduct>) { this._products = v; } public get products(): ObservableArray<singleProduct> { return this._products;} private _products: ObservableArray<singleProduct>;

    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetProductPlacesInWarehouse',{
                FurtherQueryInfo:filteringInformation,
                WarehouseId:this.warehouseId
            });
            let rowNumber = 1;
            this.products.update(...result.MeasuredProducts.map(q=>{
                let r = new singleProduct(this);
                r.id = q.Id;
                r.rowNumber = rowNumber++;
                r.measuredProductId = q.MeasuredProductId;
                r.productName = q.ProductName;
                r.productCode = q.ProductCode;
                r.unitName = q.UnitName;
                r.joinWarehouseNames = q.Locations.map(w=>w.Name).join(', ');
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }

    async confirm(){
        try {
            this.isLoading = true;
            if(this.selectedProducts.length==0){
                this.messageBoxConfirmWarning("هیچ کالایی انتخاب نشده است.",'خطا');
                return;
            }
            if(this.locations.length==0){
                let result = await this.messageBoxWarningYesNo('هیچ مکانی انتخاب نشده است. برای کالاهای منتخب مکان حذف خواهد شد. آیا اطمینان دارید؟','حذف مکان');
                if(result=='no'){
                    return;
                }
            }
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/SetProductPlacementBatch',{
                MeasuredProducts:this.selectedProducts.map(x=>x.measuredProductId),
                WarehouseParty: this.warehouseId,
                Places:this.locations.map(x=>x.locationId)
            });
            if(result.IsSuccessful==false){
                this.messageBoxConfirmWarning("عملیات ناموفق","خطا در انجام عملیات");
            }else{
                this.messageBoxConfirmSuccess("عملیات با موفقیت انجام شد","عملیات موفق");
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
        this.closePopup(true);
    }
    async back(){
        this.closePopup(false);
    }
}

export class singleProduct extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:batchPlacementUpdater) {
        super(parent);
        this._typedParent = parent;
    }
    private _typedParent : batchPlacementUpdater;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set measuredProductId(v: string) { this._measuredProductId = v; } public get measuredProductId(): string { return this._measuredProductId;} private _measuredProductId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode;} private _productCode: string;
    public set unitName(v: string) { this._unitName = v; } public get unitName(): string { return this._unitName;} private _unitName: string;
    public set joinWarehouseNames(v: string) { this._joinWarehouseNames = v; } public get joinWarehouseNames(): string { return this._joinWarehouseNames;} private _joinWarehouseNames: string;
    public set rowNumberBatch(v: number) { this._rowNumberBatch = v; } public get rowNumberBatch(): number { return this._rowNumberBatch;} private _rowNumberBatch: number;
    
    add(){
        this._typedParent.selectedProducts.push(this);
        this._typedParent.selectedProducts.forEach((x,i)=>{
            x.rowNumberBatch = i+1;
        })
    }

    remove(){
        this._typedParent.selectedProducts.remove(this);
        this._typedParent.selectedProducts.forEach((x,i)=>{
            x.rowNumberBatch = i+1;
        })
    }
}